import React from "react";
import {Card, CardContent, CardHeader, Container} from "@mui/material";
import { object, string, number, boolean, date, TypeOf, coerce } from 'zod';
import {formatDateTime, formatDateTimeParam, formatDate, formatTime} from "../../../../utils/formatDate.ts";
import * as crudgen from "../../../../share";
import {DEBOUNCE_TIME} from "../../../../utils/constants";
import {useLocation} from "react-router";

import { GroupType, GroupTypePairs, toString as toStringGroupType } from "../../../types/models/GroupType.d";


import { t, msg } from "@lingui/core/macro"





export const initialFormStateFn = () => { return {
    
        
        refreshToken: "",
        
    
        
        device: "",
        
    
} }

export const useLocationFormState = (oldState) => {
    const initialFormState = initialFormStateFn()
    let location = useLocation();
    

    return initialFormState
}

export const formObject = {
    
    
        refreshToken:
        string()
        .trim()
        .min(1, msg`Refresh Token is required`),
    
    
        device:
        string()
        .trim()
        .nullish(),
    
};

export const formSchema = object(formObject);

const UserSessionUpdateForm = ({watch, prefix = ''})  => {
    return (
        <Container>
            
            
   
   <crudgen.FormInput
       required
       name={ prefix + 'refreshToken' }
       aria-label="refreshToken"
       data-testid="refreshToken"
       label={t`Refresh Token`}
       
       type='text'
       
   />
   
   
            
            
   
   <crudgen.FormInput
       
       name={ prefix + 'device' }
       aria-label="device"
       data-testid="device"
       label={t`Device`}
       
       type='text'
       
   />
   
   
            
        </Container>
    )
}

export default UserSessionUpdateForm;
